const containers = document.querySelectorAll('[data-scrolling-element]');

function updateAlign() {
    if (containers.length === 0) return;
    for (const container of containers) {
        if (container.scrollWidth > container.clientWidth) {
            container.style.justifyContent = 'flex-start';
        } else {
            container.style.justifyContent = 'center';
        }
    }
}

const collapsibleContent = (buttonsSelector, className, contentSelector) => {
    const buttons = document.querySelectorAll(buttonsSelector);
    for (const button of buttons) {
        const container = button.parentElement.querySelector(contentSelector);
        if (container) {
            container.style.height = '0';
        }

        button.addEventListener('mouseenter', (el) => {
            const content = el.currentTarget.parentElement.querySelector(contentSelector);

            if (el.currentTarget.classList.contains(className)) {
                content.style.height = '0';
                el.currentTarget.classList.remove(className);
                el.currentTarget.firstElementChild.classList.add('feather-chevron-down');
                el.currentTarget.firstElementChild.classList.remove('feather-chevron-up');
            } else {
                el.currentTarget.classList.add(className);
                el.currentTarget.firstElementChild.classList.remove('feather-chevron-down');
                el.currentTarget.firstElementChild.classList.add('feather-chevron-up');
                content.style.height = `${content.scrollHeight}px`;
            }
        });
    }
}
function onSelectRendered(select) {
    select.disabled = true;
}

function processSelects() {
    document.querySelectorAll(".amp-bundles__select__field:not([data-observed])")
        .forEach(select => {
            select.setAttribute("data-observed", "true");
            onSelectRendered(select);
        });
}

const selectFinder = new MutationObserver(() => {
    processSelects();
});

selectFinder.observe(document.body, {
    childList: true,
    subtree: true
});

window.addEventListener('resize', updateAlign);
window.addEventListener('DOMContentLoaded', () => {
    collapsibleContent('[data-collapsible-menu-link]', 'open', '[data-collapsible-sub-menu]');
});
updateAlign();


// Bundle products

const bundleProducts = () => {
	const bundleProducts = document.querySelectorAll('[data-bundle-card]');
	const inputs = [ ...document.querySelectorAll('[data-bundle-input]')];
	const addToCartButton = document.querySelector('[data-bundle-button]');
	const parentContainer = addToCartButton?.closest('.product-form-buttons');
	let notice = document.querySelector('[data-bundle-notice] span');

	for (const product of bundleProducts) {
		product.addEventListener('click', (evt) => {
			const current = evt.currentTarget;
			if (current.classList.contains('selected')) {
				current.classList.remove('selected');
				addToCartButton.disabled = true;
				notice.innerHTML = parseInt(notice.innerHTML) - 1;
				return;
			}

			const selectedItems = Array.from(bundleProducts).filter(el => {
				return el.classList.contains('selected');
			});

			if (selectedItems.length === 0) {
				current.classList.add('selected')
				inputs[0].value = current.dataset.bundleTitle;
				notice.innerHTML = selectedItems.length + 1;
				addToCartButton.disabled = true;
			} else if (selectedItems.length === 1) {
				current.classList.add('selected')
				inputs[1].value = current.dataset.bundleTitle;
				notice.innerHTML = selectedItems.length + 1;
				addToCartButton.disabled = true;
			} else if (selectedItems.length === 2) {
				current.classList.add('selected')
				inputs[2].value = current.dataset.bundleTitle;
				notice.innerHTML = selectedItems.length + 1;
				if (parentContainer && !parentContainer.classList.contains('disabled-btn')) {
					addToCartButton.disabled = false;
				}
			}
		})
	}
}

bundleProducts()

/****** Ajax search ******/
let searchToken = 0;
let collectionCountCache = {};
window.biggestCollectionURL = null;

$('[data-search-custom-input]').each(function() {
	var _this = $(this),
		searchResult = _this.closest('#minisearch-popup').find('.search-result'),
		searchWrapper = _this.closest('#minisearch-popup').find('.search-result-wrapper'),
		collectionResult = _this.closest('#minisearch-popup').find('.collection-search'),
		collectionLabel = _this.closest('#minisearch-popup').find('.collection-search').data('label'),
		notfoundtext = $(this).attr('data-no-result-text'),
		productImgWidth = $('.predictive-search img').width(),
		productImgHeight = $('.predictive-search img').height();

	_this.on('keyup change paste', debounce(function() {
		var query = _this.val();
		searchToken++;
		let currentToken = searchToken;
		if (query.length > 2) {
			$('.predictive-wrapper').hide();
			searchResult.empty();
			collectionResult.empty();

			$.getJSON(`${window.Shopify.routes.root}search/suggest.json`, {
				"q": query,
				"resources": {
					"type": "product,collection",
					"limit": 10,
					"options": {
						"prefix": "last",
						"unavailable_products": "last",
						"fields": "title,product_type,vendor,variants.title,variants.sku,tag"
					}
				}
			}).done(function(response) {

				if (currentToken !== searchToken) return;
				var products = response.resources.results.products;
				var collections = response.resources.results.collections;

				if (products.length > 0) {
					$.each(products, function(index, item) {
						if (index >= 4) return false;

						const imgHtml = item.featured_image?.url
							? `<span class="img"><img src="${item.featured_image.url}" loading="lazy" width="${productImgWidth}" height="${productImgHeight}"/></span>`
							: "";

						var el = $(`<div class="col">
                            <a href="${item.url}">
                                ${imgHtml}
                                <span class="details">
                                    ${item.title}
                                    <span class="price d-block">${Shopify.formatMoney(item.price)}</span>
                                </span>
                            </a>
                        </div>`);
						searchResult.append(el);
					});
				} else {
					searchResult.append(`<div class="no-result text-center">${notfoundtext}</div>`);
				}

				if (collections.length > 0) {

					let countPromises = [];
					let collectionsData = [];

					collections.forEach(function(col) {

						if (collectionCountCache[col.handle] !== undefined) {
							collectionsData.push({
								url: col.url,
								title: col.title,
								count: collectionCountCache[col.handle]
							});

							return;
						}

						let promise = $.get(`/collections/${col.handle}?section_id=collection-count`)
							.then(function(countHtml) {

								if (currentToken !== searchToken) return;

								let count = parseInt($(countHtml).text().trim(), 10);
								collectionCountCache[col.handle] = count;
								collectionsData.push({
									url: col.url,
									title: col.title,
									count: count
								});
							});

						countPromises.push(promise);
					});

					Promise.all(countPromises).then(function() {

						if (currentToken !== searchToken) return;

						if (collectionsData.length > 0) {

							let biggest = collectionsData.reduce((a, b) =>
								a.count > b.count ? a : b
							);
							window.biggestCollectionURL = biggest.url;

							let link = $(`
                                <div class="more-action text-center">
                                    <a href="${biggest.url}" class="btn btn-black btn-small">${collectionLabel}</a>
                                </div>
                            `);

							collectionResult.append(link);
						}
					});
				}

				searchWrapper.fadeIn(300);
			});

		} else {
			searchResult.empty();
			collectionResult.empty();
			$('.predictive-wrapper').show();

		}
	}, 300));
});

$('#form-minisearch').on('submit', function(e){
	if (window.biggestCollectionURL) {
		e.preventDefault();
		window.location.href = window.biggestCollectionURL;
	}
});